<div class="toast-wrapper">
  <div class="toast-header">
    <mat-icon class="toast-icon">{{ data.icon }}</mat-icon>
    <span class="toast-title">{{ data.title }}</span>
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="toast-desc">
    <div></div>
    <div class="toast-message" [innerHTML]="sanitizedMessage"></div>
  </div>
</div>
